import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "flex items-center text-sm w-full" };
import { UITextSmMedium } from '@gohighlevel/ghl-ui';
import { inject } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PaymentLinkName',
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    setup(__props) {
        const props = __props;
        const router = inject('router');
        function openPaymentLinkEditor() {
            const item = props.item;
            return router.push({
                name: 'payment-links-editor',
                params: { locationId: item?.altId, id: item?._id },
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(UITextSmMedium), { class: "md:w-20 lg:w-44 xl:w-60 text-ellipsis truncate hover:whitespace-normal font-bold text-black" }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", {
                            class: "cursor-pointer",
                            onClick: openPaymentLinkEditor
                        }, _toDisplayString(__props.item?.linkName), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
